import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;
const SHOP_TOKEN_KEY = "veripool_shop_token";

export const shopApi = axios.create({ baseURL: API_BASE });

shopApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(SHOP_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setShopToken = (token) => localStorage.setItem(SHOP_TOKEN_KEY, token);
export const getShopToken = () => localStorage.getItem(SHOP_TOKEN_KEY);
export const clearShopToken = () => localStorage.removeItem(SHOP_TOKEN_KEY);

export const formatFcfa = (value) =>
  `${Math.round(Number(value || 0)).toLocaleString("fr-FR")} FCFA`;
